const T = require("react").PropTypes;

const Response = require("./Response.js");

const Error = {
    PropType: T.shape({
        message: T.string.isRequired,
        Response: Response.PropType
    })
};

module.exports = Error;


// WEBPACK FOOTER //
// ./src/types/Error.js